import React, { useEffect } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers';

import { entitiesCleanUp } from 'state/actions/stations';
import { useFormatMessage } from 'hooks';
import { getFormFieldsComponents, getCardComponent } from 'utils/schema';

import './index.scss';

const EntityForm = ({
  isEditing,
  isCreating,
  entity,
  entityInfos,
  onSubmitHandler,
  schema,
  options,
}) => {
  const {
    i18nEntityName,
    i18nScreenName,
    entitiesName,
    // entityName,
    // contactEntitiesName,
    PATH_ENTITIES,
  } = entityInfos;
  const { loading, success } = useSelector(
    (state) => ({
      loading: state[entitiesName].loading,
      success: state[entitiesName].success,
    }),
    shallowEqual
  );

  const dispatch = useDispatch();

  const action = isCreating ? 'create' : 'edit';

  // Acording to action, get the appropriate schema
  const yupDefaultSchema = schema && schema.yupSchema;
  const yupCreateSchema =
    (schema && schema.yupCreateSchema) || yupDefaultSchema;
  const yupSchema = isCreating ? yupCreateSchema : yupDefaultSchema;

  const { register, handleSubmit, errors, setValue } = useForm({
    defaultValues: { ...entity },
    resolver: yupResolver(yupSchema),
  });

  useEffect(() => {
    return () => dispatch(entitiesCleanUp());
  }, [dispatch, success, setValue]);

  const goBackMessage = useFormatMessage(`${i18nScreenName}.goBack`);

  const block = schema.blocks[0];
  const cards = [
    {
      header: {
        title: useFormatMessage(`${i18nEntityName}.info`),
        icon: 'mdi mdi-information-outline',
      },
      fields: getFormFieldsComponents(block, errors, register, action, entity, {
        i18nEntityName,
        ...options,
      }),
    },
  ];

  return (
    <>
      <div className="tile is-ancestor">
        <div className="tile is-parent">
          <div className="card tile is-child">
            <form onSubmit={handleSubmit(onSubmitHandler)}>
              {cards.map(getCardComponent)}

              <hr />
              <div className="field is-horizontal">
                <div className="field-label" />
                <div className="field-body">
                  <div className="field">
                    <div className="field is-grouped">
                      <div className="control">
                        <button
                          type="submit"
                          className={`button is-primary ${
                            loading && 'is-loading'
                          }`}
                        >
                          <span>
                            {useFormatMessage(`${i18nScreenName}.submit`)}
                          </span>
                        </button>
                      </div>
                      {isCreating && (
                        <Link to={PATH_ENTITIES} className="button">
                          {goBackMessage}
                        </Link>
                      )}
                      {isEditing && (
                        <Link
                          to={`${PATH_ENTITIES}/${entity.id}/profile`}
                          className="button"
                        >
                          {goBackMessage}
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

EntityForm.propTypes = {
  // entity: PropTypes.shape({
  //   id: PropTypes.string,
  //   name: PropTypes.string,
  //   address: PropTypes.shape({
  //     line1: PropTypes.string,
  //     line2: PropTypes.string,
  //     postalCode: PropTypes.string,
  //     city: PropTypes.string,
  //     country: PropTypes.string,
  //   }),
  //   createdAt: PropTypes.string,
  // }).isRequired,
  // onSubmitHandler: PropTypes.func.isRequired,
  //
  // eslint-disable-next-line react/forbid-prop-types
  schema: PropTypes.object.isRequired,
  isCreating: PropTypes.bool,
  isEditing: PropTypes.bool,
};

EntityForm.defaultProps = {
  isCreating: false,
  isEditing: false,
};

export default EntityForm;
